import { PulseStorage } from '@pulse/common';

export class WebToMobileService {
    private readonly KEY_W2M_META_INFO: string = 'w2m_meta_info';
    private w2mMetaInfo?: Record<string, any> | null;
    private metaInfoInLocalStorage = false;

    constructor(
        protected readonly cookieStorage: PulseStorage,
        protected readonly unprefixedStorage: PulseStorage,
    ) {
        try {
            const w2mMetaInfo = this.cookieStorage.get(this.KEY_W2M_META_INFO);
            const w2mMetaInfoFromStorage = this.unprefixedStorage.get(this.KEY_W2M_META_INFO);
            this.metaInfoInLocalStorage = Boolean(w2mMetaInfoFromStorage);

            if (w2mMetaInfo) {
                this.w2mMetaInfo = JSON.parse(w2mMetaInfo);
            } else if (w2mMetaInfoFromStorage) {
                this.w2mMetaInfo = JSON.parse(w2mMetaInfoFromStorage);
            }
        } catch (e) {
            console.error('Error getting web to mobile configuration', e);
        }
    }

    /**
     * Get the device unique identifier
     */
    getWebToMobileMetaInfo(): Record<string, any> | null {
        if (this.w2mMetaInfo) {
            return this.w2mMetaInfo;
        }

        return null;
    }

    isMetaInfoInLocalStorage(): boolean {
        return this.metaInfoInLocalStorage;
    }
}
